import Leaflet from "leaflet";
import redMarker from "../css/images/marker-icon-red.png";
import greenMarker from "../css/images/marker-icon-green.png";
import orangeMarker from "../css/images/marker-icon-orange.png";

export const activeIcon = Leaflet.icon({
  iconUrl: orangeMarker,
  iconSize: [25, 41],
  popupAnchor: [1, -16],
  iconAnchor: [12, 41]
});

export const normalIcon = Leaflet.icon({
  iconUrl: greenMarker,
  iconSize: [25, 41],
  popupAnchor: [1, -16],
  iconAnchor: [12, 41]
});

export const unapprovedIcon = Leaflet.icon({
  iconUrl: redMarker,
  iconSize: [25, 41],
  popupAnchor: [1, -16],
  iconAnchor: [12, 41]
});



/** WEBPACK FOOTER **
 ** ./src/utils/map-icons.js
 **/